<template>
    <div class="review">
        <div class="review__header">
            <div class="review__avatar">
                <Avatar :url="avatarUrl" :webp-url="webpAvatarUrl" :name="name" size="medium" />
            </div>
            <div class="review__info">
                <div>
                    <div class="review__name">{{ name }}</div>
                    <div class="review__reviewed-at">{{ reviewedAt }}</div>
                </div>
                <Ratings :value="overallScore" class="review__ratings" />
            </div>
        </div>
        <p class="review__comment">
            {{ overallComment }}
        </p>
    </div>
</template>

<script>
import Avatar from '~/components/Avatar.vue';
import Ratings from '~/components/Ratings.vue';

export default {
    components: {
        Avatar,
        Ratings,
    },
    props: {
        review: {
            type: Object,
            default: () => {},
        },
        showReviewee: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        reviewedAt() {
            return this.review.createdAt ? this.$options.filters.dateFormat(this.review.createdAt, 'MMM yyyy') : '';
        },
        name() {
            if (this.showReviewee) {
                return this.review.revieweeName || null;
            }

            if (this.review.reviewerName) {
                return this.review.reviewerName;
            }

            return '––';
        },
        avatarUrl() {
            if (this.showReviewee) {
                return this.review.revieweeAvatarUrl || null;
            }

            return this.review.reviewerAvatarUrl || null;
        },
        webpAvatarUrl() {
            if (this.showReviewee) {
                return this.review.revieweeWebpAvatarUrl || null;
            }

            return this.review.reviewerWebpAvatarUrl || null;
        },
        overallScore() {
            return this.review.overallScore;
        },
        overallComment() {
            return this.review.overallComment;
        },
    },
};
</script>

<style lang="scss">
@import '@/sass/_variables.scss';

.review {
    @include font-size(16px);

    &__avatar {
        margin-right: 20px;
        width: 60px;
        height: 60px;
    }

    &__header {
        display: flex;
    }

    &__info {
        display: flex;
        flex-grow: 1;
        justify-content: space-between;
        align-items: flex-start;
        min-height: 68px;
    }

    &__name {
        font-weight: bold;
        display: inline-block;
    }

    &__comment {
        margin-bottom: 0;
        margin-top: 8px;

        @include lg {
            padding-left: 80px;
            margin-top: 0;
        }
    }

    &__reviewed-at {
        color: $secondary-text-color;
    }

    &__ratings {
        display: inline-block;
    }
}
</style>
